/**
 * Represents the tracking status of a letter if its Sandboxx status is `SENT`
 */
export const SentLetterTrackingStatus = Object.freeze({
    DELIVERED: "DELIVERED",
    IN_TRANSIT: "IN_TRANSIT",
    NO_TRACKING: "NO_TRACKING",
    PENDING: "PENDING",
});
